// extracted by mini-css-extract-plugin
export default {"header":"g9l1QsBkTOu5z4Uk5jHg","headline":"RGFyQdJMb6ZHeFZ__2Om","list":"bDKFtuORBNC6mFZatTl9","pagination":"nkFZtH9kiwzrY2ss7N7T"};